import { useUserGetByIamId } from '@cldsystems/ws-api-client';
import { useKeycloak } from '@/providers/keycloak-provider';

export type AccountLocale = {
  locale: string | undefined;
  isLoading: boolean;
};

export const useAccountLocale = (): AccountLocale => {
  const { keycloak, isAuthenticated } = useKeycloak();
  const iamId = keycloak?.idTokenParsed?.sub ?? '';
  const enabled = Boolean(isAuthenticated && iamId);
  const { data, isLoading } = useUserGetByIamId({
    params: { iamId },
    enabled,
  });

  return {
    locale: data?.user?.locale?.toLowerCase(),
    isLoading: enabled && isLoading,
  };
};

export default useAccountLocale;
